<template>
  <div class="surgeon-satisfaction" v-if="dataLoaded">

    <div class="top">
      <chart-item class='chart-summary' :data="mainReport" :isLink="false" :colorOverride="'#2E96D6'" :percentColorOverride="'#2E96D6'" />
      <chart-item-filter v-if="showIolFilter(0)"
        :iols="iols"     
        class='chart-summary'
        v-model="iolFilters[0]"
        @input="iolFilterChanged(0)"
      />
      <chart-item v-if="subReports[0].report"
        class='chart-summary'
        :isLink="false"
        :canClose="true"
        :colorOverride="'#DF5B96'"
        :percentColorOverride="'#2E96D6'"
        :data="subReports[0].report"
        @close="iolFilterClosed(subReports[0].report.name)"
      />
      <chart-item-filter v-if="showIolFilter(1)"
        :iols="iols"
        class='chart-summary'
        v-model="iolFilters[1]"
        @input="iolFilterChanged(1)"
      />
      <chart-item v-if="subReports[1].report"
        class='chart-summary'
        :isLink="false"
        :canClose="true"
        :colorOverride="'#F2C94C'"
        :percentColorOverride="'#2E96D6'"
        :data="subReports[1].report"
        @close="iolFilterClosed(subReports[1].report.name)"
      />
      <chart-item-filter v-if="showIolFilter(2)"
        :iols="iols"      
        class='chart-summary'
        v-model="iolFilters[2]"
        @input="iolFilterChanged(2)"
      />
      <chart-item v-if="subReports[2].report"
        class='chart-summary'
        :isLink="false"
        :canClose="true"
        :colorOverride="'#F09639'"
        :percentColorOverride="'#2E96D6'"
        :data="subReports[2].report"
        @close="iolFilterClosed(subReports[2].report.name)"
      />
    </div>

    <div class="chart-main">
      <div class="chart-actions">
        <div class="chart-dropdown">
          <rp-dropdown
            v-model="currentChart"
            :data-model="chartTypes"
            disable-search
            object-label="name"
            placeholder="Time Period"
            tempIdentifier="Type"
            iconText="View Scores By:"
          />
        </div>
        <div class="filter" v-if="false">
          <rp-dropdown
            v-model="dateSelected"
            :data-model="dates"
            disable-search
            placeholder="Select year"
            tempIdentifier="Time"
            iconText="Show data from:"
            @input="getReports"
          />
        </div>
      </div>
      <Bar v-if="this.currentChart && this.currentChart.value=='BarChart'"
        id="bar-satisfaction"
        :chart-data="barChartData"
        :chart-options="barChartOptions"
        :height="300"
      />
      <LineChartGenerator v-if="this.currentChart && this.currentChart.value=='LineChart'"
        id="line-satisfaction"
        :chart-data="lineChartData"
        :chart-options="lineChartOptions"
        :height="300"
      />
    </div>

  </div>
</template>

<script>
  import ChartItem from '../ChartItem_v2'
  import ChartItemFilter from '../ChartItemFilter_v2'
  import SelectField from 'raypro_ui/src/components/ui/inputs/StyledSelect'
  import RpSprite from 'raypro_ui/src/components/ui/Sprite'
  import Dropdown from 'raypro_ui/src/components/ui/inputs/dropdown/Dropdown'
  import breakdown from '../../../../mixins/breakdown'
  // Chart.js
  import {Bar, Line as LineChartGenerator} from 'vue-chartjs/legacy'
  import {Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, LineElement, PointElement} from 'chart.js'
  import ChartjsPluginStacked100 from 'chartjs-plugin-stacked100'
  import ChartDataLabels from 'chartjs-plugin-datalabels'
  ChartJS.register(Title, Tooltip, Legend, BarElement, LineElement, CategoryScale, LinearScale, PointElement, ChartjsPluginStacked100, ChartDataLabels)

  export default {
    mixins: [breakdown],

    components: {
      Bar,
      LineChartGenerator,
      ChartItem,
      ChartItemFilter,
      RpSprite, 
      SelectField, 
      'rp-dropdown': Dropdown,
    },

    data() {
      return {
        report: {},
        globalReport: {},
        subReports: [
          {report: null, filter: '', color: '#DF5B96'},
          {report: null, filter: '', color: '#F2C94C'},
          {report: null, filter: '', color: '#F09639'},
        ],
        chartTypes: [
          {name: 'Time Period', value: 'LineChart'},
          {name: 'Distribution', value: 'BarChart'},
        ],
        currentChart: {name: 'Time Period', value: 'LineChart'},
        barChartData: {
          datasets: [
            {label: 'Satisfaction with Surgeon', borderColor:'#2E96D6', backgroundColor: '#2E96D6', data: []}
          ]
        },
        lineChartData: {
          datasets: [
            {label: 'Satisfaction with Surgeon', borderColor:'#2E96D6', backgroundColor: '#2E96D6', data: [], spanGaps: true}
          ]
        },
        lineChartAnnotationDataset: {
          label: 'Average', borderColor:'#1ED7C6', borderWidth: 2, borderDash: [10, 5], backgroundColor: '#FFF', data: [],
        },
        barChartOptions: {
          indexAxis: 'y',
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            x: {
              stacked: true,
              ticks: {
                callback: function(label, index, labels) {
                  return `${label}%`
                }
              },
            },
            y: {
              stacked: true,
            },
          },
          layout: {
            padding: {
              top: 33,
            }
          },
          plugins: {
            stacked100: {
              enable: true,
              replaceTooltipLabel: true,
            },
            datalabels: {
              anchor: 'center',
              align: 'center',
              color: 'black',
              formatter: (_value, context) => {
                const data = context.chart.data
                const { datasetIndex, dataIndex } = context
                return `${data.originalData[datasetIndex][dataIndex]}`
              },
            },
            legend: {
              display: true,
              position: 'bottom',
            }
          },
        },
        lineChartOptions: {
          responsive: true,
          maintainAspectRatio: false,
          layout: {
            padding: {
              top: 33,
            }
          },
          plugins: {
            datalabels: {
              display: false,
            },
            legend: {
              display: true,
              position: 'bottom',
            },
          },
          scales: {
            x: {
              grid: {
                display: false,
              },
            },
            y: {
              min: 0,
              max: 100,
              title: {
                display: true,
                text: 'Satisfaction',
              },
              ticks: {
                stepSize: 20,
                callback: (label) => {
                  return `${label}%`
                }
              },
            },
          },
        },
      }
    },

    computed: {
      mainReport() {
        if (this.filterParams.includes('iol=') === false) {
          return this.report
        } else {
          return this.truncateReportToTimeSpan(this.globalReport)
        }
      },
    },

    methods: {
      async getReports() {
        this.report = await this.getReportByIdPromise(this.filterParams)
        this.globalReport = this.getGlobalReport(this.report.name, this.report.slug)[0]

        this.lineChartData.datasets.splice(1)
        this.lineChartData.datasets[0].data = this.getTimesForReport(this.mainReport)
        this.lineChartData.datasets[0].label = this.mainReport.name

        await this.getSubReports()
        this.processBarData()
        this.dataLoaded = true
      },

      processBarData() {
        var reports = [this.mainReport]
        for (var i = 0; i < 3; i++) {
          if (this.subReports[i].report) {
            reports.push(this.subReports[i].report)
          }
        }

        this.barChartData.datasets = this.generateBarData(reports)
        this.barChartData.labels = this.generateBarLabels(reports)
      },

      generateBarData(reports) {
        var data = []
        const groups = ['0-2', '3-5', '6-8', '9-10']
        const colors = ['#4472C4', '#ED7D31', '#A5A5A5', '#FFC000']

        for (var i = 0; i < groups.length; i++) {
          data.push({
            label: groups[i],
            backgroundColor: colors[i],
            data: this.getGroupData(groups[i], reports)
          })
        }

        return data
      },

      generateBarLabels(reports) {
        if (reports.length == 1) {
          return ['']
        }

        var labels = []
        for (var i = 0; i < reports.length; i++) {
          labels.push(reports[i].name)
        }
        return labels
      },

      getGroupData(group, reports) {
        var groupData = []
        for (var i = 0; i < reports.length; i++) {
          groupData.push(this.dataToGroups(reports[i].report_datas.data))
        }

        var retVal = []
        for (var i = 0; i < groupData.length; i++) {
          retVal.push(groupData[i][group])
        }
        return retVal
      },

      dataToGroups(data) {
        var newData = {"0-2": 0, "3-5": 0, "6-8": 0, "9-10": 0}
        for (const [key, value] of Object.entries(data)) {
          const intKey = parseInt(key)
          if (intKey >= 0 && intKey <= 2) {
            newData["0-2"] += value
          } else if (intKey >= 3 && intKey <= 5) {
            newData["3-5"] += value
          } else if (intKey >= 6 && intKey <= 8) {
            newData["6-8"] += value
          } else if (intKey >= 9 && intKey <= 10) {
            newData["9-10"] += value
          }
        }
        return newData
      },

      async getSubReports() {
        const models = this.getModelNamesFromFilterParams()
        for (const model of models) {
          let index = 0
          const filterItem = this.iolFilters.find(x => x && x.model === model)
          if (filterItem) {
            index = this.iolFilters.indexOf(filterItem)
          }

          const filterParams = this.getSubReportFilterParams(models.indexOf(model))
          let report = await this.getReportByIdPromise(filterParams)
          report.name = model
          this.subReports[index].report = report
          this.subReports[index].filter = filterParams
        }

        this.renderSubReports()
      },

      renderSubReports() {
        this.lineChartData.datasets = this.lineChartData.datasets.slice(0, 1)
        for (var i = 0; i < 3; i++) {
          if (this.subReports[i].report) {
            this.lineChartData.datasets.push({
              label: this.subReports[i].report.name,
              borderColor: this.subReports[i].color,
              backgroundColor: this.subReports[i].color,
              spanGaps: true,
              data: this.getTimesForReport(this.subReports[i].report)
            })
          }
        }
      },

      updateSubReports() {
        this.subReports.forEach((subReport) => {
          if (subReport.report && !this.iolFilters.find((x) => x && x.model === subReport.report.name)) {
            subReport.filter = ''
            subReport.report = null
          }
        })
      },

      downloadReport() {
        this.getExportReportPromise(this.$route.params.report_id, this.report.slug).then((res) => {
          this.downloadResult(res)
        })
      },

      setDownloadOptions() {
        this.$emit('setDownloadOptions', ['Satisfaction'])
      },

      iolFilterChanged(index) {
        if (this.iolFilters[index]) {
          if (this.iolFilters[index] && !this.subReports.find(x => x.report && x.report.name === this.iolFilters[index].model)) {
            this.$emit('addIolFilter', this.iolFilters[index].id)
          } else {
            this.iolFilters[index] = null
          }
        }
      },

      iolFilterClosed(model) {
        const iol = this.iolFilters.find((x) => x && x.model === model)
        this.subReports[this.iolFilters.indexOf(iol)].filter = ''
        this.subReports[this.iolFilters.indexOf(iol)].report = null
        this.iolFilters[this.iolFilters.indexOf(iol)] = null
        this.$emit('removeIolFilter', iol.id)
      },
    }
  }
</script>

<style lang="sass">
  @import 'raypro_ui/src/styles/base/_variables.sass'
  @import 'raypro_ui/src/styles/helpers/_mixins.sass'

  .surgeon-satisfaction
    display: flex
    flex-direction: column
    width: 100%
    min-width: 768px    
    padding: 10px
    margin-right: -30px
    box-shadow: $color-shadow
    background-color: transparent

    .top
      display: flex
      flex-direction: column
      justify-content: flex-start
      width: 100%
      gap: 40px
      
      @include media($media-small)
        flex-direction: row

      .chart-summary
        margin-right: 0px

    .chart-main
      width: 100%
      border-radius: 20px
      background-color: $color-panel-bg

      .chart-actions
        color: $color-text
        width: 189px
        margin-left: auto
        margin-right: 18px
        margin-bottom: -34px

        @include media($media-small)
          align-items: center

</style>



// WEBPACK FOOTER //
// src/components/pages/Dashboard/Breakdowns/SatisfactionSurgeon_v2.vue